import type { TelemetryConfig } from '@tbitop/telemetry';
import type { StageParameters } from '../../stage/stage-parameters';

export type TelemetryEnvSetting = ReturnType<typeof getTelemetryConfig>;

export const getTelemetryConfig = (
  { instrumentationKey }: StageParameters,
): TelemetryConfig => ({
  instrumentationKey,
});
